import React from "react";
import guideMainHero from "../../../assets/images/guide/guide_main_hero.png";
import guideMainRecommend from "../../../assets/images/guide/guide_main_recommend.png";
import guideMainStrength from "../../../assets/images/guide/guide_main_strength.png";
import guideMainUsage from "../../../assets/images/guide/guide_main_usage.png";
import guideMainApply from "../../../assets/images/guide/guide_main_apply.png";
import guideMainFaq from "../../../assets/images/guide/guide_main_faq.png";
import guideMainFaqBtn from "../../../assets/images/guide/guide_main_faq_btn.png";
import guideMainFaqTextBtn from "../../../assets/images/guide/guide_main_faq_text_btn.png";
import guideMainFaqTextBtn2 from "../../../assets/images/guide/guide_main_faq_text_btn2.png";
import guideMainFinal from "../../../assets/images/guide/guide_main_final.png";
import guideMainFinalBtn from "../../../assets/images/guide/guide_main_final_btn.png";
import guideMainFinalNotice from "../../../assets/images/guide/guide_main_final_notice.png";
import Air10431 from "./Air10431";
// import '../../../scss/views/guide/guideView_Air202509.scss';

const Air202509 = () => {
  const loginGuideUrl = `${process.env.REACT_APP_LOGIN_URL}/?referer_url=${process.env.REACT_APP_REFERER_URL}`;

  return (
    <div id="air2509_container" className="air2509_layout-contents">
      <div className="air2509_bg bg_hero">
        <div className="area air2509_hero_area">
          <img
            className="air2509_hero_image"
            src={guideMainHero}
            alt="탐구활동 AI 솔루션 과학동아AiR"
          />
        </div>
      </div>
      <Air10431 />
      <div className="air2509_bg bg_recommend">
        <div className="area air2509_recommend_area">
          <img
            className="air2509_recommend_image"
            src={guideMainRecommend}
            alt="과학동아AiR 추천 대상"
          />
        </div>
      </div>
      <div className="air2509_bg bg_strength">
        <div className="area air2509_strength_area">
          <img
            className="air2509_strength_image"
            src={guideMainStrength}
            alt="과학동아AiR 핵심 강점"
          />
        </div>
      </div>
      <div className="air2509_bg bg_usage">
        <div className="area air2509_usage_area">
          <img
            className="air2509_usage_image"
            src={guideMainUsage}
            alt="과학동아AiR 이용 가이드"
          />
        </div>
      </div>
      <div className="air2509_bg bg_apply">
        <div className="area air2509_apply_area">
          <img
            className="air2509_apply_image"
            src={guideMainApply}
            alt="과학동아AiR 활용 가이드"
          />
        </div>
      </div>
      {/* <div className="air2509_bg bg_udok_green">
        <div className="area">
          <img
            src="https://img.dongascience.com/air/air202509/12-title.png"
            alt="12"
          />
        </div>
      </div>
      <div className="air2509_bg bg_udok_green">
        <div className="area">
          <img
            src="https://img.dongascience.com/air/air202509/13-u.png"
            alt="13"
          />
        </div>
      </div>
      <div className="air2509_bg bg_udok_green">
        <div className="area">
          <a
            href="https://www.lguplus.com/pogg/product/%EC%9C%A0%EB%8F%85-%EB%9D%BC%EC%9D%B4%EB%84%88-%EB%8D%94%EB%B8%94-ai"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src="https://img.dongascience.com/air/air202509/13btn.png"
              alt="13btn"
            />
          </a>
        </div>
      </div>
      <div className="air2509_bg bg_udok_green">
        <div className="area">
          <img
            src="https://img.dongascience.com/air/air202509/14-u.png"
            alt="14"
          />
        </div>
      </div>
      <div className="air2509_bg bg_udok_green">
        <div className="area">
          <a
            href="https://www.lguplus.com/pogg/product/%EC%9C%A0%EB%8F%85-%EA%B3%BC%ED%95%99%EB%8F%99%EC%95%84-ai-pick"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src="https://img.dongascience.com/air/air202509/14btn.png"
              alt="14btn"
            />
          </a>
        </div>
      </div> */}
      <div className="air2509_bg bg_faq_image">
        <div className="area air2509_faq_image_area">
          <img
            className="air2509_faq_image"
            src={guideMainFaq}
            alt="과학동아AiR 자주 묻는 질문"
          />
          <a
            className="air2509_faq_text_btn_link"
            href={loginGuideUrl}
            target="_blank"
            rel="noreferrer"
          >
            <img
              className="air2509_faq_text_btn_image"
              src={guideMainFaqTextBtn}
              alt="로그인 하러가기"
            />
          </a>
          <a
            className="air2509_faq_text_btn2_link"
            href="https://dsstore.dongascience.com/product/gzs7BGyv"
            target="_blank"
            rel="noreferrer"
          >
            <img
              className="air2509_faq_text_btn2_image"
              src={guideMainFaqTextBtn2}
              alt="AI패스 구매 하러가기"
            />
          </a>
          <a
            className="air2509_faq_btn_link"
            href="https://help.dongascience.com/contents/list/101000"
            target="_blank"
            rel="noreferrer"
          >
            <img
              className="air2509_faq_btn_image"
              src={guideMainFaqBtn}
              alt="FAQ 바로 가기"
            />
          </a>
        </div>
      </div>

      {/* <div className="air2509_bg bg_faq_gray">
        <div className="area">
          <img src="https://img.dongascience.com/air/air202509/15.png" alt="15" />
        </div>
      </div> */}
      <div className="air2509_bg bg_final">
        <div className="area air2509_final_area">
          <div className="air2509_final_main">
            <img
              className="air2509_final_image"
              src={guideMainFinal}
              alt="과학동아AiR 마지막 안내"
            />
            <a
              className="air2509_final_btn_link"
              href="https://dsstore.dongascience.com/product/gzs7BGyv"
              target="_blank"
              rel="noreferrer"
            >
              <img
                className="air2509_final_btn_image"
                src={guideMainFinalBtn}
                alt="바로 구매하기"
              />
            </a>
          </div>
        </div>
      </div>
      <div className="air2509_bg bg_final_notice">
        <div className="area air2509_final_notice_area">
          <img
            className="air2509_final_notice_image"
            src={guideMainFinalNotice}
            alt="유의사항"
          />
        </div>
      </div>
    </div>
  );
};
export default Air202509;
